import React from "react";

const TopBar = () => {
  return (
    <>
      <style>
        {`
        .topbar {
          background: #006a4f;
          color: white;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px; /* Increased font size */
          width: 100%;
          z-index: 1000;
          flex-wrap: wrap;
          padding: 10px 20px;
        }

        .topbar p {
          margin: 0;
          flex: 1;
          text-align: center;
          font-size: 18px; /* Increased text size */
          font-weight: 500;
        }

        .topbar a {
          color: yellowgreen;
          text-decoration: none;
          font-weight: bold;
          font-size: 16px; /* Ensure link is readable */
        }

        .btn-container {
          display: flex;
          align-items: center;
        }

        .phone-btn {
          background: yellowgreen;
          color: #000;
          border: none;
          padding: 10px 16px; /* Increased button padding */
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px; /* Increased button font size */
          font-weight: 600;
        }

        /* Responsive Styles */
        @media (max-width: 992px) {
          .topbar {
            flex-direction: column;
            text-align: center;
            padding: 15px;
          }

          .btn-container {
            margin-top: 10px;
          }

          .phone-btn {
            width: 100%;
            text-align: center;
          }
        }
        `}
      </style>

      <div className="topbar p-3">
        <p>
          <span style={{ color: "yellowgreen" }} className="me-1">CoderMonk:</span>
          Your coding journey, powered by DigitalMonk
          <a href="https://digitalmonk.biz" target="_blank" rel="noopener noreferrer" className="ms-1">
            Check out the official website!
          </a>
        </p>
       
      </div>
    </>
  );
};

export default TopBar;
